import { render, staticRenderFns } from "./GroupSelect.vue?vue&type=template&id=16756612&scoped=true&"
import script from "./GroupSelect.vue?vue&type=script&lang=ts&"
export * from "./GroupSelect.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSelect.vue?vue&type=style&index=0&id=16756612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16756612",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
